import React, {Component, Fragment} from 'react'
import {Row, Col, Button} from 'reactstrap'
import autobind from 'auto-bind'
import PropTypes from 'prop-types'

export default class StaticTitleText extends Component {
    deprecated = true
    propComponents = [
        {
            prop: 'name',
            component: 'GenericWidgetName',
        },
    ]
    showBorder = false
    id = 'StaticTitleText'
    requiredOutputs = []
    static propTypes = {
        name: PropTypes.string,
    }
    constructor(props) {
        super(props)
        autobind(this)
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col className="text-center">
                        <h1>{this.props.name}</h1>
                    </Col>
                </Row>
            </Fragment>
        )
    }
}
